import TreatmentDetailPanel from './TreatmentDetailPanel'

export default TreatmentDetailPanel
